import React from 'react';
import { FiAlertTriangle } from 'react-icons/fi';

/**
 * Bandeau affiché quand le backend signale que les drapeaux ENEDIS n'ont pas
 * pu être lus (`degraded` contient 'enedis_flags', ex. statement timeout de la
 * RPC enedis_pdl_data_flags). Sans lui, les PDL concernés apparaîtraient
 * « À connecter » à tort.
 */
export default function EnedisDegradedBanner({ degraded, warnings, onRetry, className = '' }) {
  if (!Array.isArray(degraded) || !degraded.includes('enedis_flags')) return null;
  const message = (Array.isArray(warnings) && warnings[0])
    || 'Données ENEDIS indisponibles : la progression des fichiers reçus est incomplète.';
  return (
    <div
      role="alert"
      data-testid="enedis-degraded-banner"
      className={`flex items-center gap-2 border border-amber-200 bg-amber-50 px-3 py-2 text-[11px] text-amber-800 ${className}`}
    >
      <FiAlertTriangle className="h-3.5 w-3.5 flex-shrink-0" aria-hidden />
      <span>
        {message} Les PDL marqués « Données ENEDIS indisponibles » ne sont pas forcément à connecter.
      </span>
      {onRetry && (
        <button type="button" onClick={onRetry} className="ml-auto underline whitespace-nowrap">
          Réessayer
        </button>
      )}
    </div>
  );
}
